import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';

import { useWebView } from '@myrealtrip/device-detect';

import type { TransportationProduct } from '~models/Transportation/PointToPointTicket';

import Thumbnail from './Card/Thumbnail';
import Summary from './Card/Summary';
import CTA from './Card/CTA';

interface Props {
  product: TransportationProduct;
  sectionTitle: string;
  sectionVerticalIndex: number;
  itemIndex: number;
}

const PassCard = ({ product, sectionTitle, sectionVerticalIndex, itemIndex }: Props) => {
  const { isWebView } = useWebView();

  const { productUrls } = product ?? {};

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLDivElement>,
  ) => {
    e.stopPropagation();

    if (!productUrls) {
      return;
    }

    const url = isWebView ? productUrls.APP : productUrls.WEB;
    window.location.href = url;
  };

  return (
    <Container onClick={handleClick}>
      <Thumbnail product={product} />
      <Content>
        <Summary product={product} />
        <CTA
          product={product}
          sectionTitle={sectionTitle}
          sectionVerticalIndex={sectionVerticalIndex}
          itemIndex={itemIndex}
          onClick={handleClick}
        />
      </Content>
    </Container>
  );
};

export default PassCard;

const Container = styled.div`
  ${media.minMobile} {
    cursor: pointer;
  }
`;

const Content = styled.div`
  padding: 16px;
  border-radius: 0 0 12px 12px;
  border-right: 1px solid ${({ theme }) => theme.colors.gray.s100};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s100};
  border-left: 1px solid ${({ theme }) => theme.colors.gray.s100};
`;
